import styled, { css } from 'styled-components';
import { AppBar } from 'src/components/atoms/PageHeader/PageHeader.styled';
import MuiPagination from '@mui/material/Pagination';
import { hexToRgba } from 'src/utils';

export const StyledBar = styled(AppBar)<{
  $small?: boolean;
}>`
  &.MuiAppBar-root {
    top: unset;
    bottom: 0;
    min-height: 70px;
    padding: 6px 20px;
    border-bottom: unset;
    border-top: 1px solid ${(props) => props.theme?.colors.borderColor};

    ${(props) =>
      props.$small &&
      css`
        min-height: unset;

        padding: 12px 16px;
      `}

    @media screen and (max-width: 470px) {
      flex-direction: column;
    }
  }
`;

export const StyledPagination = styled(MuiPagination)`
  & .MuiButtonBase-root {
    color: ${(props) => props.theme?.colors.textColor};

    &:hover {
      background-color: ${(props) => hexToRgba(props.theme?.colors.grey3 || '', 1)};
    }

    &.Mui-selected {
      color: ${(props) => props.theme?.colors.primaryDark};
      background-color: ${(props) => hexToRgba(props.theme?.colors.primary || '', 0.1)};
      font-weight: 600;
    }
  }

  & .MuiPaginationItem-ellipsis {
    color: ${(props) => props.theme?.colors.textColor};
  }
`;
